import { render, staticRenderFns } from "./CalendarElement.vue?vue&type=template&id=80722aba&"
import script from "./CalendarElement.vue?vue&type=script&lang=js&"
export * from "./CalendarElement.vue?vue&type=script&lang=js&"
import style0 from "./CalendarElement.vue?vue&type=style&index=0&id=80722aba&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports